<section class="vc-admin-customers-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.CUSTOMERS.TITLE"
    descriptionKey="ADMIN.CUSTOMERS.DESCRIPTION"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'ADMIN.CUSTOMERS.ADD' | translate"
      (click)="router.navigate(['/administration/customers/new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (customers.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.CUSTOMERS.EMPTY.TITLE"
      descriptionKey="ADMIN.CUSTOMERS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="customers"
      styleClass="Table"
      responsiveLayout="scroll"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.NAME' | translate }}</th>
          <th>{{ 'ADMIN.BUSINESS_CATEGORIES.NAV' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-customer>
        <tr>
          <td>{{ customer.name }}</td>
          <td>{{ getCategoriesLabel(customer) }}</td>
          <td>
            <button
              pButton
              type="button"
              size="small"
              class="p-button-text"
              icon="pi pi-briefcase"
              [label]="'ADMIN.CUSTOMERS.ACCOUNT.BUTTON' | translate"
              (click)="router.navigate(['/administration/customers', customer.id, 'account'])"
            ></button>
            <app-admin-table-actions
              [manageLabelKey]="'ADMIN.CUSTOMERS.ENTER'"
              [manageDisabled]="managingCustomerId === customer.id"
              [manageLoading]="managingCustomerId === customer.id"
              (manage)="manageCustomer(customer)"
              (delete)="confirmDelete(customer)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
